/*
 *
 * DO NOT EDIT, this is automatically generated by main.py
 */

export const AUTH_CONFIG = {
	domain: 'aeleads.auth0.com',
	clientId: 'mJXa1HvU3zAibYtjS3n92bZB4dSdVA5W',
	callbackUrl: 'https://nightsky.aeleads.com:443/callback'
};



// WEBPACK FOOTER //
// ./src/auth/config.js